import React from 'react';
const BOOKLETS = [{
  n: 'i',
  label: 'Recurso principal',
  title: 'La Guía de\nTransformación\nCorporal'
}, {
  n: 'ii',
  label: 'Biblioteca de claridad',
  title: 'Código de\nRecuperación'
}, {
  n: 'iii',
  label: 'Biblioteca de claridad',
  title: 'Guion de\nConsulta'
}, {
  n: 'iv',
  label: 'Biblioteca de claridad',
  title: 'Línea de Tiempo\nde Transformación'
}];
export function ProductMockup() {
  return <div className="mockup" aria-hidden="true" data-id="element-103">
      <div className="mockup-grid" data-id="element-104">
        {BOOKLETS.map((b, idx) => <article key={b.n} className="booklet" style={{
        '--booklet-rot': `${[-1.2, 0.8, -0.6, 1.4][idx]}deg`
      } as React.CSSProperties} data-id="element-105">
            <div className="booklet-inner" data-id="element-106">
              <header className="booklet-top" data-id="element-107">
                <span className="booklet-mark" data-id="element-108">A.R.M.O.N.Y.</span>
                <span className="booklet-num" data-id="element-109">{b.n}</span>
              </header>

              <h4 className="booklet-title" data-id="element-110">
                {b.title.split('\n').map((line, i) => <span key={i} className="booklet-title-line" data-id="element-111">
                    {line}
                  </span>)}
              </h4>

              <footer className="booklet-foot" data-id="element-112">
                <span className="booklet-label" data-id="element-113">{b.label}</span>
              </footer>
            </div>
          </article>)}
      </div>
      <p className="mockup-caption" data-id="element-114">Cuatro recursos. Un solo método.</p>
    </div>;
}